import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from '@src/hooks/useAuth';
import { DropdownSelect, useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './ProfileBar.module.scss';
export const ProfileBar = () => {
    const navigate = useNavigate();
    const { t } = useLocale();
    const { currentUser, logout, isClientAdmin } = useAuth();
    const handleProfileClick = async (e) => {
        const value = e.target.value;
        if (value === 'profile') {
            return navigate('/admin/profile');
        }
        if (value === 'employee_view') {
            return navigate('/');
        }
        if (value === 'logout') {
            await logout();
            return navigate('/login');
        }
    };
    const options = useMemo(() => {
        const opt = [
            { label: t('Profile'), value: 'profile' },
            { label: t('Sign Out'), value: 'logout' },
        ];
        if (isClientAdmin) {
            opt.unshift({ label: t('Employee View'), value: 'employee_view' });
        }
        return opt;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isClientAdmin]);
    return (_jsx("div", { "data-testid": 'profile-bar', className: styles.profileBar, children: (currentUser && (_jsx(DropdownSelect, { btnClass: 'w-full', label: currentUser.firstName, onChange: handleProfileClick, options: options }))) || _jsx(Link, { to: '/login', children: t('Sign In') }) }));
};
